import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from "dayjs";
import { deleteRailCalendar, editRailCalendar, getRailCalendars } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import AddNewCalendar from "./Modal/AddNewCalendar";
import { toast } from "react-toastify";
import { Modal as ModalAntd } from "antd";
import { format } from "date-fns";
import AccessForbidden from "../../../Access/AccessForbidden";
import { style } from "../style";
import Loading from "../../../../components/Loading/Loading";

const RailCalendar = () => {
    const {state} = useAuth();
    const [open, setOpen] = useState(false);
    const [calendars, setCalendars] = useState<any>([]);
    const [expDate, setExpDate] = useState<any>(dayjs());
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    const getCalendars = async () => {
        const response = await getRailCalendars(state.user?.token);
        if(response?.response?.status === 403) {
            setIsAdmin(true);
        } else {
            setCalendars(response || []);
        }
        setLoading(false);
    }

    const deleteCalendar = async (id: any, railYearStart: any) => {
        const response: any = await deleteRailCalendar(state.user?.token, id, railYearStart);
        if(response.status === 200) {
            toast.error("Rail Calendar deleted successfully!");
            getCalendars();
        } else {
            toast.error("Somwthing went wrong!")
        }
    }

    const editCalendar = async (id: any) => {
        const response = await editRailCalendar(state.user?.token, id, format(expDate.$d, 'yyyy-MM-dd'))
        if(response?.status) {
            toast.success("Updated successfully!")
        }
    }

    useEffect(() => {
        getCalendars();
    }, [])

    if(loading) {
        return <Loading />
    }

    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <Box>
            <Box display="flex" justifyContent={"space-between"} m={2}>
                <Typography variant="h6">Rail Calendars</Typography>
                <Button
                    variant="contained"
                    sx={{boxShadow: "none"}}
                    onClick={() => setOpen(true)}
                >
                    Add New Calendar
                </Button>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 4
                }}>
                {Array.isArray(calendars) && calendars.map((calendar: any) => (
                    <Box m={2}>
                        <Typography fontWeight={'bold'}>Calendar Start Date</Typography>
                        <Box display="flex" m={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker
                                        slotProps={{textField: { size: 'small' } }}
                                        label="Date"
                                        value={calendar.railYearStart ? dayjs(calendar.railYearStart) : null}
                                        format="DD/MM/YYYY"
                                        onChange={(value) => setExpDate(value)} />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => editCalendar(calendar.id)}
                                sx={{ml: 2, mt: 1, boxShadow: "none", height: 40}}
                            >
                                Save Changes
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                sx={{ml: 2, mt: 1, boxShadow: "none", height: 40, backgroundColor: "red"}}
                                onClick={() => 
                                    ModalAntd.confirm({
                                        title: `Are you sure you want to delete ${calendar.railYearStart}?`,
                                        onOk: () => deleteCalendar(calendar.id, calendar.railYearStart),
                                        okButtonProps: { danger: true },
                                        okText: 'YES',
                                        cancelText: 'NO',
                                        centered: true
                                    })
                                }>
                                    Delete
                            </Button>
                        </Box>
                    </Box>
                ))}
            </Box>
            <Modal
                title={`Add New Post`}
                onClose={() => setOpen(false)}
                open={open}
            >
                <Box sx={style}>
                    <AddNewCalendar getCalendars={getCalendars} setOpen={setOpen} />
                </Box>
            </Modal>
        </Box>
    )
}

export default RailCalendar;
